// extracted by mini-css-extract-plugin
export default {"root":"_1cIEQnSo","label":"_3O2qFkye","value":"_1hQSAKZ3"};